import type { ComponentProps } from 'react';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons/index.tsx';
import { iconArcade } from '@sorare/core/src/atoms/icons/system/iconArcade.ts';
import { ShieldShape } from '@sorare/core/src/atoms/ui/ShieldShape/index.tsx';

import { arcadeModeGradient } from '#src/lib/gameMode.ts';

type Props = {
  size?: ComponentProps<typeof ShieldShape>['size'];
};

export const ArcadeModeIcon = ({ size = 'xxs' }: Props) => (
  <ShieldShape
    size={size}
    orientation="up"
    borderColor={arcadeModeGradient}
    icon={<FontAwesomeIcon icon={iconArcade} />}
  />
);
